import { api } from '@/api/client'

export interface VinculoGitlab {
  vinculado: boolean
  gitlab_username: string | null
  revogado: boolean
  configurado: boolean
}

export const CHAVE_VINCULO_GITLAB = 'gitlab-vinculo'
export const getVinculoGitlab = (): Promise<VinculoGitlab> =>
  api.get('/v1/me/gitlab').then((r) => r.data)
export const conectarGitlab = (): Promise<{ url: string }> =>
  api.post('/v1/me/gitlab/conectar').then((r) => r.data)
export const concluirVinculoGitlab = (code: string, state: string): Promise<{ gitlab_username: string }> =>
  api.post('/v1/me/gitlab/callback', { code, state }).then((r) => r.data)
export const desvincularGitlab = (): Promise<{ desvinculado: boolean }> =>
  api.delete('/v1/me/gitlab').then((r) => r.data)
